

































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { HorizontalScrollType } from '../../models';
import { SUBMODULES_PATHS } from '../../store';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.core, ['horizontalScrollType'])
  }
})
export default class SlidingPanel extends Vue {

  @Prop({ default: true })
  showButtons: boolean;

  @Prop({ default: true })
  show: boolean;

  isScrollAtStart = true;
  isScrollAtEnd = true;

  horizontalScrollType: HorizontalScrollType;

  scrollStart = 0;
  scrollEnd = 0;
  scrollDistance = 0;
  scrollWidth = 0;
  scrollReverse = false; // Flag for RTL horizontal scrolling support in IE/Edge
  scrollFactor = 0.7;

  $refs: {
    scroll: HTMLElement
  };

  @Watch('scrollDistance')
  checkScrollPosition() {
    if (this.$refs.scroll) {
      this.isScrollAtStart = this.scrollReverse
        ? this.scrollDistance >= this.scrollStart
        : this.scrollDistance <= this.scrollStart;
      this.isScrollAtEnd = this.scrollReverse
        ? this.scrollDistance <= this.scrollEnd
        : this.scrollDistance >= this.scrollEnd;
    } else {
      this.isScrollAtStart = this.isScrollAtEnd = true;
    }
  }

  @Watch('show')
  resetScroll() {
    this.$refs.scroll.scrollTo(this.scrollDistance, 0);
  }

  storeScroll() {
    this.scrollDistance = this.$refs.scroll.scrollLeft;
    this.scrollWidth = this.$refs.scroll.scrollWidth;
  }

  scrollLeft() {
    this.$refs.scroll.scrollBy({ left: -this.$refs.scroll.clientWidth * this.scrollFactor, behavior: 'smooth' });
  }

  scrollRight() {
    this.$refs.scroll.scrollBy({ left: this.$refs.scroll.clientWidth * this.scrollFactor, behavior: 'smooth' });
  }

  mounted() {
    this.checkScrollPosition();
  }

  updated() {
    this.checkScrollPosition();
  }

  // tslint:disable-next-line
  // TODO: Fix weird bug with Firefox when the component is already scrolled and the @after-end transition hook is called before it has really finished
  private setValues() {
    const { scroll } = this.$refs;
    this.scrollDistance = scroll.scrollLeft;
    this.scrollFactor = 0.7;
    this.scrollReverse = false;

    switch (this.horizontalScrollType) {
      case HorizontalScrollType.NEGATIVE:
        this.scrollStart = scroll.clientWidth - scroll.scrollWidth;
        this.scrollEnd = 0;
        break;

      case HorizontalScrollType.REVERSE:
        this.scrollStart = scroll.scrollWidth - scroll.clientWidth;
        this.scrollEnd = 0;
        this.scrollFactor *= -1;
        this.scrollReverse = true;
        break;

      case HorizontalScrollType.DEFAULT:
      default:
        this.scrollStart = 0;
        this.scrollEnd = scroll.scrollWidth - scroll.clientWidth;
        break;
    }
  }

  @Watch('horizontalScrollType')
  @Watch('scrollWidth')
  setInitialValues() {
    const previousScrollDistance = this.scrollDistance;

    if (this.$refs.scroll) {
      this.setValues();
      if (previousScrollDistance === this.scrollDistance) {
        this.checkScrollPosition();
      }
    }
  }
}
